import { storeToRefs } from 'pinia';
import type { Address } from '~~/types/commercetools';

import { billingDetailsStore } from '~/stores/billingDetails';

import { useBilling } from '~/utils/ct';

export default function () {

  const store = billingDetailsStore();
  const { billingDetails } = storeToRefs(store);

  const {
    billing: address,
  } = useBilling();

  const { defaultAddress } = useCheckout();

  if (!billingDetails.value?.firstName) {

    store.setBillingDetails(address.value || defaultAddress);

  }

  const setBillingDetailsMutation = (billingDetails: Partial<Address>) => {

    const addressToSet = billingDetails || address.value || defaultAddress;
    store.setBillingDetails(addressToSet);
  
  };

  return {
    ...store,
    billingDetails,

    setBillingDetailsMutation,
  };

}